import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const KEY = "threec_active_project_id";

const Ctx = createContext({
  project: null,
  projectId: null,
  loaded: false,
  setActiveProjectId: () => {},
  refresh: () => {},
});

export function ActiveProjectProvider({ children }) {
  const [projectId, setProjectId] = useState(() => localStorage.getItem(KEY) || null);
  const [project, setProject] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async (id) => {
    try {
      const url = id ? `/dashboard?project_id=${id}` : "/dashboard";
      const { data } = await api.get(url);
      setProject(data);
      if (data?.id) {
        setProjectId(data.id);
        localStorage.setItem(KEY, data.id);
      }
    } catch (e) {
      setProject(null);
      if (id) {
        setProjectId(null);
        localStorage.removeItem(KEY);
      }
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load(projectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setActiveProjectId = useCallback(
    (id) => {
      setProjectId(id);
      localStorage.setItem(KEY, id || "");
      load(id);
    },
    [load]
  );

  const refresh = useCallback(() => load(projectId), [projectId, load]);

  return (
    <Ctx.Provider value={{ project, projectId, loaded, setActiveProjectId, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export function useActiveProject() {
  return useContext(Ctx);
}
